import { combineReducers } from "redux";
import lungRe from "./lungRe";
import prostateRe from "./prostateRe";
import breastRe from "./breastRe";
import thyroidRe from './thyroidRe';
import survey from "./survey";
import loading from "./loading";
import total from "./total";

export default combineReducers({
  lungRe,
  loading,
  prostateRe,
  survey,
  total,
  breastRe,
  thyroidRe,
});
